<template>
	<div class="terminal puiformheader">
		<v-layout wrap>
			<v-flex xs12 md6>
				<pui-field :label="this.$t('vtcterminales.nombre')" :value="getNombre"></pui-field>
			</v-flex>
			<v-flex xs12 md6>
				<pui-field :label="this.$t('vtcterminales.cif')" :value="getCif"></pui-field>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import PuiFormHeaderMixin from 'pui9-mixins/PuiFormHeaderMixin';

export default {
	name: 'terminalformheader',
	mixins: [PuiFormHeaderMixin],
	data() {
		return {
			modelName: 'terminal'
		};
	},
	computed: {
		getNombre() {
			return this.model && this.model.nombre ? this.model.nombre : '';
		},
		getCif() {
			return this.model && this.model.cif ? this.model.cif : '';
		}
	},
	methods: {
		extendFilter(filter) {
			// Ya que es una tabla con varias vistas para que funcione correctamente se necesita indicar el modelo
			filter.model = 'terminal';
		}
	}
};
</script>
<style lang="postcss" scoped></style>
<i18n>
{
	"en": {
        "vtcterminales.nombre": "Name",
        "vtcterminales.cif": "Tax identifier"
    },
    "es": {
        "vtcterminales.nombre": "Nombre",
        "vtcterminales.cif": "Identificador fiscal"
    },
    "ca": {
        "vtcterminales.nombre": "Nom",
        "vtcterminales.cif": "Identificador fiscal"
    }
}
</i18n>
